module.exports = __webpack_public_path__ + "static/media/step3.25653760.svg";